"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var flyout_1 = require("spry-react/Flyout/flyout");
var flyoutToggle_1 = require("spry-react/Flyout/flyoutToggle");
var labeled_1 = require("spry-react/Label/labeled");
var lockToggle_1 = require("spry-react/Label/lockToggle");
var arrayExtensions_1 = require("spry-react/utils/arrayExtensions");
var errorUtils_1 = require("spry-react/utils/errorUtils");
var idGenerator_1 = require("spry-react/utils/idGenerator");
var _ = require("underscore");
var selectField_1 = require("../Select/selectField");
require("../Warnings/warning.less");
require("./multiselectField.less");
var MultiselectField = /** @class */ (function (_super) {
    __extends(MultiselectField, _super);
    function MultiselectField(props) {
        var _this = _super.call(this, props) || this;
        _this.onChangeWrapper = function (values) {
            _this.props.onChange(values.map(function (o) { return o.value; }));
        };
        _this.shouldShowFilterInput = function () {
            return _this.props.options.length > 9;
        };
        _this.renderMultiselectFieldFlyout = function () {
            var filtering = _this.state.filtering;
            var clearClass = _this.state.filteringInput === ""
                ? "field-clear"
                : "field-clear visible";
            var filter = _this.shouldShowFilterInput()
                ? React.createElement("div", { className: "multiselectfield-filter" },
                    React.createElement("span", { className: clearClass, title: 'Clear', onClick: _this.clearInput }),
                    React.createElement("input", { type: "search", placeholder: "Type to filter", style: { fontSize: "1em", padding: 0, paddingLeft: ".6em", border: 0 }, onChange: _this.onFilterInputChange, value: _this.state.filteringInput, ref: function (r) { return _this.filterInputElement = r; } }))
                : null;
            var filterRegEx = filtering ? MultiselectField.getFilterRegEx(_this.state.filteringInput) : undefined;
            var scroll = function (scroll) {
                var scrolled = (scroll == 0) ? false : true;
                if (scrolled != _this.state.isScrolled)
                    _this.setState({ isScrolled: scrolled });
            };
            var scrollDebounce = _.debounce(scroll, 25);
            var selectAllSelected = filtering
                ? _this.state.filteredOptionsState.length !== 0 && _this.state.filteredOptionsState.filter(function (o) { return _this.selectedOptions().indexOf(o) > -1; }).length === _this.state.filteredOptionsState.length
                : _this.props.options.length === _this.selectedOptions().length;
            var selectAllCheck = selectAllSelected ? "checkbox-checked-icon" : "checkbox-unchecked-icon";
            var selectAllClass = classNames(_this.state.isScrolled ? "scrolled" : "not-scrolled", _this.state.filteredOptionsState.length === 0 ? "disabled" : null);
            var header = React.createElement("li", { tabIndex: -1, ref: function (r) { return _this.selectAllElement = r; }, className: selectAllClass, style: { display: "flex" }, key: "selectAll", onClick: function () { return filtering ? _this.selectAllFilteredOptions(_this.state.filteredOptionsState) : _this.selectAllOptions(); }, onKeyDown: function (event) { return filtering ? _this.spaceBarSelectFilter(_this.state.filteredOptionsState, event) : _this.spaceBarSelectAll(event); } },
                React.createElement("div", { className: "multiselect-check-field" },
                    React.createElement("div", { className: selectAllCheck })),
                !_this.state.filtering
                    ? React.createElement("div", null, " Select All ")
                    : React.createElement("div", null,
                        " Select (",
                        _this.state.filteredOptionsState.length,
                        ") "));
            var multiselectFieldOptions = _this.state.filteredOptionsState.map(function (o) {
                var isSelected = _this.selectedOptions().some(function (a) { return (a.value == o.value); });
                var checkedClass = isSelected ? "checkbox-checked-icon" : "checkbox-unchecked-icon";
                var userClasses = (_this.props.getListItemClasses && _this.props.getListItemClasses(o)) || undefined;
                var optionClasses = classNames("text-ellipsis", userClasses);
                return React.createElement("li", { tabIndex: -1, "data-multiselect-value": o.value, style: { display: "flex" }, key: o.value, onKeyDown: function (event) { return _this.spaceBarSelectOption(o, isSelected, event); }, onClick: function () { return _this.selectOption(o, isSelected); } },
                    React.createElement("div", { className: "multiselect-check-field" },
                        React.createElement("div", { className: checkedClass })),
                    !filtering
                        ? React.createElement("div", { className: optionClasses },
                            " ",
                            o.text || '\u00A0',
                            " ")
                        : React.createElement(selectField_1.HighlightedSegments, { text: o.text, filterRegEx: filterRegEx }));
            });
            return React.createElement("div", { ref: function (r) { return _this.flyoutElement = r; }, onKeyDown: _this.keyPressToggleDropdown },
                filter,
                header,
                React.createElement("ul", { onScroll: function (e) { return scrollDebounce(e.currentTarget.scrollTop); } }, multiselectFieldOptions));
        };
        _this.keyPressToggleDropdown = function (e) {
            if (_this.state.dropdownIsOpen === false) {
                //opens when any arrow key, enter, space, or any letter or number is pressed. IE and Edge values accounted for
                var keysThatOpen = ["Down", "ArrowDown", "Up", "ArrowUp", "Left", "ArrowLeft", "Right", "ArrowRight", "Spacebar", " ", "Enter"];
                if ((e.key.length === 1 && e.key >= 'a' && e.key <= 'z') ||
                    (e.key >= "0" && e.key <= "9") ||
                    (keysThatOpen.indexOf(e.key) > -1)) {
                    e.preventDefault();
                    _this.toggleDropdown();
                }
            }
            else {
                var keysThatClose = ["Esc", "Escape", "Tab"];
                if (keysThatClose.indexOf(e.key) > -1) {
                    _this.closeDropdown();
                }
                var upDownArrows = ["Down", "ArrowDown", "Up", "ArrowUp"];
                if (upDownArrows.indexOf(e.key) > -1) {
                    e.preventDefault();
                    var direction = (e.key === "Down" || e.key === "ArrowDown") ? 'down' : 'up';
                    var optionList = void 0;
                    if (_this.shouldShowFilterInput()) {
                        optionList = ['filter', 'selectall'];
                    }
                    else {
                        optionList = ['selectall'];
                    }
                    var nextFocusElement_1 = _this.getNextFocusElement(direction, optionList.concat(_this.state.filteredOptionsState));
                    if (_this.state.focusedElement != nextFocusElement_1) {
                        _this.setState(function () {
                            return { focusedElement: nextFocusElement_1 };
                        });
                    }
                }
            }
        };
        _this.getNextFocusElement = function (direction, optionList) {
            var currFocused = _this.state.focusedElement;
            var currFocusedIndex = arrayExtensions_1.findIndex(optionList, function (item) { return item === currFocused; });
            if (direction === "up") {
                return currFocusedIndex - 1 >= 0 ? optionList[currFocusedIndex - 1] : currFocused;
            }
            else {
                return currFocusedIndex + 1 < optionList.length ? optionList[currFocusedIndex + 1] : currFocused;
            }
        };
        _this.toggleDropdown = function () {
            _this.setState(function (prevState) {
                var nextFocusElement;
                if (prevState.dropdownIsOpen) {
                    nextFocusElement = null;
                }
                else {
                    if (_this.shouldShowFilterInput()) {
                        nextFocusElement = 'filter';
                    }
                    else {
                        nextFocusElement = 'selectall';
                    }
                }
                return { dropdownIsOpen: !prevState.dropdownIsOpen, focusedElement: nextFocusElement };
            });
        };
        _this.closeDropdown = function () {
            _this.setState({
                dropdownIsOpen: false,
                focusedElement: null
            });
        };
        _this.onDropdownButtonClick = function () {
            /* note: the FlyoutToggle component will handle opening the flyout */
            _this.focusInput();
        };
        _this.focusInput = function () {
            if (_this.inputElement)
                _this.inputElement.focus();
        };
        _this.clearInput = function () {
            _this.setState({
                filteringInput: "",
                filtering: false,
                filteredOptionsState: _this.props.options
            });
        };
        _this.onFilterInputChange = function (e) {
            var inputValue = e.currentTarget.value;
            var filtering = inputValue === "" ? false : true;
            var filteredOptions = filtering
                ? _this.props.filterOptions(_this.props.options, inputValue)
                : _this.props.options;
            _this.setState({
                filteringInput: inputValue,
                filtering: filtering,
                filteredOptionsState: filteredOptions
            });
        };
        _this.selectOption = function (option, selected) {
            var list = selected
                ? _this.selectedOptions().filter(function (a) { return a.value != option.value && a.text != option.text; })
                : _this.selectedOptions().concat(option);
            _this.onChangeWrapper(list);
        };
        _this.spaceBarSelectOption = function (option, selected, e) {
            if (e.key === "Spacebar" || e.key === " ") {
                e.preventDefault();
                _this.selectOption(option, selected);
            }
        };
        _this.selectAllOptions = function () {
            var full = _this.selectedOptions().length === _this.props.options.length;
            var list = full ? [] : _this.props.options;
            _this.onChangeWrapper(list);
        };
        _this.spaceBarSelectAll = function (e) {
            if (e.key === "Spacebar" || e.key === " ") {
                e.preventDefault();
                _this.selectAllOptions();
            }
        };
        _this.selectAllFilteredOptions = function (options) {
            var selectedFilteredOptions = options.filter(function (o) { return _this.selectedOptions().indexOf(o) > -1; });
            var unselectedFilteredOptions = selectedFilteredOptions.length === 0
                ? options
                : options.filter(function (o) { return selectedFilteredOptions.indexOf(o) < 0; });
            var full = selectedFilteredOptions.length === options.length;
            var list = full ? _this.selectedOptions().filter(function (o) { return options.indexOf(o) < 0; }) : _this.selectedOptions().concat(unselectedFilteredOptions);
            _this.onChangeWrapper(list);
        };
        _this.spaceBarSelectFilter = function (options, e) {
            if (e.key === "Spacebar" || e.key === " ") {
                e.preventDefault();
                _this.selectAllFilteredOptions(options);
            }
        };
        _this.selectedOptions = function () {
            var value = _this.props.value;
            if (!value)
                return [];
            var list = [];
            var _loop_1 = function (i) {
                list = list.concat(_this.props.options.filter(function (o) { return o.value == value[i]; }));
            };
            for (var i = 0; i < value.length; i++) {
                _loop_1(i);
            }
            return list;
        };
        _this.inputValue = function (limit, allSelectedText) {
            if (_this.selectedOptions().length == 0)
                return "";
            if (_this.selectedOptions().length == _this.props.options.length && allSelectedText)
                return allSelectedText;
            var size = _this.selectedOptions().length > limit ? limit : _this.selectedOptions().length;
            var values = [];
            var temp;
            for (var i = 0; i < _this.props.options.length; i++) {
                if (_this.selectedOptions().some(function (o) { return (o.value == _this.props.options[i].value); }))
                    temp = _this.props.options[i].text;
                else
                    continue;
                if (values.length < size)
                    values = values.concat(temp);
                else
                    break;
            }
            var more = limit >= _this.selectedOptions().length
                ? ""
                : " and " + (_this.selectedOptions().length - limit) + " more";
            var string = values.join(", ");
            return string + more;
        };
        _this.state = {
            generatedId: "multiselectfield-" + idGenerator_1.GenerateId(),
            dropdownIsOpen: false,
            isScrolled: false,
            displayedInputValue: "",
            filtering: false,
            filteringInput: "",
            focusedElement: null,
            filteredOptionsState: _this.props.options
        };
        return _this;
    }
    MultiselectField.prototype.render = function () {
        var _this = this;
        var _a = this.props, disabled = _a.disabled, flyoutSizeMode = _a.flyoutSizeMode, required = _a.required, errorMessage = _a.errorMessage, title = _a.title;
        var dropdownIsOpen = this.state.dropdownIsOpen;
        var selectedOptionsTextLimit = this.props.selectedOptionsTextLimit || 3;
        var displayedInputValue = this.inputValue(selectedOptionsTextLimit, this.props.allSelectedText);
        var inputId = this.props.id || this.state.generatedId;
        var fieldClasses = classNames('dropdown-field');
        var inputClasses = classNames('dropdown-input', {
            'required': required
        });
        var dropdownFlyout = dropdownIsOpen
            ? {
                key: 'dropdownFlyout',
                contents: this.renderMultiselectFieldFlyout(),
                positioningElementId: inputId,
                flyoutClassName: 'dropdown-flyout multiselect-dropdown-flyout',
                sizeMode: flyoutSizeMode || flyout_1.FlyoutSizeMode.SizeToPositioningElement,
                suppressAnimation: true
            }
            : null;
        return React.createElement(flyoutToggle_1.FlyoutClickToggle, { flyout: dropdownFlyout, toggleClickHandler: this.toggleDropdown, onClickOutsideFlyout: this.closeDropdown, disabled: disabled, disableFocusLock: false },
            React.createElement("div", { className: fieldClasses },
                React.createElement("input", __assign({ id: inputId, type: "text", value: displayedInputValue || "", disabled: disabled }, errorUtils_1.toErrorProps(inputClasses, title, errorMessage), { ref: function (input) { return _this.inputElement = input; }, readOnly: true, placeholder: this.props.placeholder, "aria-required": required, onKeyDown: this.keyPressToggleDropdown })),
                React.createElement("button", { className: "dropdown-button", tabIndex: -1, disabled: disabled, onClick: this.onDropdownButtonClick })));
    };
    MultiselectField.prototype.componentDidMount = function () {
        var input = this.inputElement;
        if (input && this.props.autoFocus)
            requestAnimationFrame(function () { return input.focus(); });
    };
    MultiselectField.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.props.options !== prevProps.options) {
            var hasFilterInputForNewOptions = this.shouldShowFilterInput();
            var newOptionsFiltered = hasFilterInputForNewOptions
                ? this.props.filterOptions(this.props.options, prevState.filteringInput)
                : this.props.options;
            this.setState({
                filteredOptionsState: newOptionsFiltered,
                filtering: hasFilterInputForNewOptions
                    ? prevState.filtering
                    : false,
                filteringInput: hasFilterInputForNewOptions
                    ? prevState.filteringInput
                    : ''
            });
        }
        if (prevState.focusedElement === this.state.focusedElement)
            return;
        if (!this.state.focusedElement)
            return;
        if (this.state.focusedElement === 'filter' && this.filterInputElement) {
            var fie_1 = this.filterInputElement;
            window.requestAnimationFrame(function () { return fie_1.focus(); });
        }
        else if (this.state.focusedElement === 'selectall' && this.selectAllElement) {
            var sae_1 = this.selectAllElement;
            window.requestAnimationFrame(function () { return sae_1.focus(); });
        }
        else {
            var multiSelectValue = this.state.focusedElement != 'filter' && this.state.focusedElement != 'selectall' ? this.state.focusedElement.value : "";
            var toFocus_1 = this.flyoutElement ? this.flyoutElement.querySelector("[data-multiselect-value=" + CSS.escape(multiSelectValue) + "]") : null;
            if (toFocus_1 != null) {
                window.requestAnimationFrame(function () { return (toFocus_1).focus(); });
            }
        }
    };
    MultiselectField.defaultFilter = function (options, filterText) {
        options = options || [];
        var filterRegEx = MultiselectField.getFilterRegEx(filterText);
        return options.filter(function (o) { return o.text.search(filterRegEx) >= 0; });
    };
    MultiselectField.getFilterRegEx = function (inputValue) {
        var escapedInput = inputValue.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
        return new RegExp("\\b" + escapedInput, 'gi');
    };
    MultiselectField.defaultProps = {
        filterOptions: MultiselectField.defaultFilter
    };
    return MultiselectField;
}(React.Component));
exports.MultiselectField = MultiselectField;
exports.LabeledMultiselectField = labeled_1.labeled(MultiselectField);
exports.LockToggleMultiselectField = lockToggle_1.lockToggle(MultiselectField);
